import { getTenantAuthentication } from '@/api/requests/AppRequests'

// 新增：从 URL 任意位置(search/hash)读取参数
function getUrlParam(name: string): string | null {
  try {
    const reg = new RegExp(`[?#&]${name}=([^&#]*)`, 'i')
    const match = window.location.href.match(reg)
    return match ? decodeURIComponent(match[1]) : null
  } catch {
    return null
  }
}

/**
 * 获取用于「微信授权」的 tenantId：
 * - 优先：从 URL 中读取 relayTenantId（或 tenantId），并缓存到本域
 * - 顶级授权域名（非中转场景） => 固定返回 '1000'
 * - 二级域名 => 先取本地缓存 sandsTalkTenantId；没有则调用 getTenantAuthentication 通过域名换取
 */
export async function getTenantIdForWeixinAuth(): Promise<string> {
  // 1) 优先读取 URL 中继参数
  const relay = getUrlParam('relayTenantId') || getUrlParam('tenantId')
  if (relay) {
    localStorage.setItem('sandsTalkTenantId', relay)
    return relay
  }

  // 3) 二级域名：尝试用缓存
  const cached = localStorage.getItem('sandsTalkTenantId')
  if (cached) return cached

  // 4) 二级域名：调用接口换取
  try {
    const domainName = window.location.origin + '/'
    const res = await getTenantAuthentication({
      code: '',
      domainName
    })
    if (res?.code === 1 && res?.data?.tenantId) {
      localStorage.setItem('sandsTalkTenantId', res.data.tenantId)
      return res.data.tenantId
    }
  } catch (e) {
    // 忽略错误，后续返回空串
  }

  // 5) 兜底：返回空串（避免误用 1000 到二级域名）
  return ''
}